import { AcademyIcon, ComplianceIcon, SrIcon } from 'ui/icons/logo';
import { Role } from '../../types';

interface AppData {
  name: string;
  shortName: string;
  icon: string;
  url: string;
}

export type RoleData = {
  name: string;
  app: AppData;
};

const SrAppData: AppData = {
  name: 'Compli One Share Registry',
  shortName: 'Share Registry',
  icon: SrIcon,
  url: import.meta.env.VITE_SR_URL,
};

const ComplianceAppData: AppData = {
  name: 'Compli One Compliance',
  shortName: 'Compliance',
  icon: ComplianceIcon,
  url: import.meta.env.VITE_COMPLIANCE_URL,
};

const academyBaseUrl = import.meta.env.VITE_ACADEMY_URL.replace(/\/+$/, '');
const academyCallbackUrl = encodeURIComponent(`/`);

const AcademyAppData: AppData = {
  name: 'Compli One Academy',
  shortName: 'Academy',
  icon: AcademyIcon,
  url: `${academyBaseUrl}/api/auth/keycloak-start?callbackUrl=${academyCallbackUrl}`,
};

export const rolesMapping: Record<Role, RoleData> = {
  [Role.SR_ADMIN]: { name: 'Admin', app: SrAppData },
  [Role.SR_ISSUER]: { name: 'Issuer', app: SrAppData },
  [Role.SR_ISSUER_ADMIN]: { name: 'Issuer admin', app: SrAppData },
  [Role.SR_INVESTOR]: { name: 'Investor', app: SrAppData },
  [Role.COMPLIANCE_ADMIN]: { name: 'Admin', app: ComplianceAppData },
  [Role.COMPLIANCE_USER]: { name: 'User', app: ComplianceAppData },
  [Role.ACADEMY_USER]: { name: 'Academy user', app: AcademyAppData },
  [Role.ACADEMY_ORGANISATION_ADMIN]: { name: 'Academy organisation admin', app: AcademyAppData },
};
